import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Aside from "./componentes/Aside";
import Header from "./componentes/Header";
import Footer from "./componentes/Footer";
import Inicio from "./pages/Inicio";
import Login from "./pages/Login"; // ✅ Corrige el nombre
import CalendarioCitas from "./pages/administrativo/CalendarioCitas";
import HistorialChats from "./pages/administrativo/HistorialChats";
import Facturacion from "./pages/administrativo/Facturacion";
import Prospectos from "./pages/administrativo/Prospectos";
import Suscriptores from "./pages/administrativo/Suscriptores";
import TelefonosNotificacion from "./pages/configuracion/TelefonosNotificacion";
import Usuario from "./pages/configuracion/Usuarios";
import Reportes from "./pages/reportes/Reportes";

function App() {
  return (
    <Router>
      <Routes>
        {/* Página de Login (sin layout) */}
        <Route path="/" element={<Login />} />

        {/* Rutas con layout */}
        <Route
          path="/*"
          element={
            <div className="wrapper">
              <Header />
              <Aside />
              <div className="content-wrapper">
                <section className="content pt-3">
                  <div className="container-fluid">
                    <Routes>
                      <Route path="inicio" element={<Inicio />} />
                      <Route path="calendario_citas" element={<CalendarioCitas />} />
                      <Route path="historial_chats" element={<HistorialChats />} />
                      <Route path="telefonos_notificacion" element={<TelefonosNotificacion />} />
                      <Route path="gestion_usuarios" element={<Usuario />} />
                      <Route path="reportes" element={<Reportes />} />
                      <Route path="facturacion" element={<Facturacion />} />
                      <Route path="prospectos" element={<Prospectos />} />
                      <Route path="suscriptores" element={<Suscriptores />} />
                      {/* Aquí puedes ir agregando más rutas internas */}
                    </Routes>
                  </div>
                </section>
              </div>
              <Footer />
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
